import { motion } from "framer-motion";
import { IMG } from "@/components/data";
import { useLang } from "@/i18n";

const META = [
  { n: "01", name: "TUpellet", img: IMG.bag_tupellet, specVals: ["78", "23", "26,91 t"] },
  { n: "02", name: "Fuoco nel Fuoco Gold", img: IMG.bag_gold, specVals: ["72", "23", "24,84 t"] },
  { n: "03", name: "Fuoco nel Fuoco Platin", img: IMG.bag_platin, specVals: ["72", "23", "24,84 t"] },
];

export default function Brands() {
  const { t } = useLang();
  const items = t.brands.items;
  return (
    <section id="marchi" className="pt-[50px] pb-[40px] md:pt-[82px] md:pb-[72px] bg-[#F4F4F4] border-y border-ink/80">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-ferrari">{t.brands.label}</span>
          <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-[0.9]">
            {t.brands.titleA}<br /><span className="text-ferrari">{t.brands.titleB}</span>
          </h2>
          <div className="mt-6 inline-flex items-center gap-3 border border-ink/80 px-5 py-3 rounded-xl">
            <span className="w-2.5 h-2.5 bg-ferrari" />
            <span className="text-xs md:text-sm font-bold uppercase tracking-[0.15em]">{t.brands.cert}</span>
          </div>
        </div>

        <div className="flex flex-col">
          {META.map((b, i) => (
            <motion.div
              key={b.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`brand-row-${i}`}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-6 items-center lg:items-stretch py-9 border-t border-ink/80 first:border-t-0"
            >
              <div className="lg:col-span-1 lg:self-center font-display font-extrabold text-5xl md:text-6xl text-ink/15 group-hover:text-ferrari transition-colors duration-300">
                {b.n}
              </div>
              <div className="lg:col-span-3 order-first lg:order-none relative h-64 lg:h-auto rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_-10px_rgba(0,0,0,0.15)]">
                <img src={b.img} alt={`Sacchetto ${b.name}`} className="absolute inset-0 w-full h-full object-contain p-2 group-hover:scale-[1.04] transition-transform duration-500" />
              </div>
              <div className="lg:col-span-5">
                <h3 className="font-display font-extrabold uppercase tracking-tight text-3xl md:text-4xl leading-none">{b.name}</h3>
                <div className="text-ferrari font-bold uppercase tracking-[0.15em] text-sm mt-2">{items[i].variant}</div>
                <p className="text-ink/60 text-sm md:text-base mt-3 leading-relaxed max-w-xl">{items[i].desc}</p>
                <div className="grid grid-cols-3 gap-3 mt-5 max-w-md">
                  {b.specVals.map((v, si) => (
                    <div key={si} className="border border-ink/80 px-3 py-3 rounded-xl">
                      <div className="font-display font-extrabold text-xl md:text-2xl leading-none text-ferrari">{v}</div>
                      <div className="text-[10px] uppercase tracking-[0.1em] text-ink/55 mt-1.5 leading-tight">{t.brands.specLabels[si]}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="lg:col-span-3 lg:self-center flex flex-wrap gap-2 lg:justify-end">
                {items[i].tags.map((tag) => (
                  <span key={tag} className={`text-[11px] font-bold uppercase tracking-[0.12em] border px-3 py-2 rounded-full ${tag.startsWith("ENplus") ? "bg-ferrari text-white border-ferrari" : "border-ink/80"}`}>{tag}</span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
